var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoWarning24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_warning24x24",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM8,13.107A1.046,1.046,0,0,1,6.947,12,1.046,1.046,0,0,1,8,10.893,1.027,1.027,0,0,1,9.053,12,1.036,1.036,0,0,1,8,13.107Zm.415-4.226c-.159.543-.661.553-.828,0a20.03,20.03,0,0,1-.877-4.628c0-2.073,2.594-2.084,2.594,0A20.5,20.5,0,0,1,8.415,8.881Z",
    fill: "#999"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoWarning24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_warning24x24.cabeecb92729dec31d70eaa5150df79d.svg";